module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAEAQMAAACTPww9AAAAA3NCSVQICAjb4U/gAAAABlBMVEX///////9VfPVsAAAAAnRSTlMA/1uRIrUAAAAJcEhZcwAACusAAArrAYKLDVoAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDkvMDkvMTGYUezuAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAAtJREFUCJljYIAAAAAIAAGvU+oiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// M:/_work/1/s/Core/OnBase.NET/third-party-assemblies/Infragistics/IgniteUI/16.2.20162.2040/css/structure/images/igGrid/blank.png
// module id = 288
// module chunks = 0